import { createTheme } from "@mui/material/styles";

export const getDesignTokens = mode => ({
  palette: {
    mode,
    ...(mode === "dark"
      ? {
          // Dark Mode
          primary: {
            main: "#3b82f6", // Modern bright blue
            light: "#60a5fa",
            dark: "#2563eb",
          },
          secondary: {
            main: "#8b5cf6", // Purple
          },
          background: {
            default: "#0f172a", // Slate 900
            paper: "#1e293b", // Slate 800
          },
          text: {
            primary: "#f8fafc", // Slate 50
            secondary: "#cbd5e1", // Slate 300
          },
          action: {
            selected: "rgba(59, 130, 246, 0.24)", // More visible selected state
            hover: "rgba(59, 130, 246, 0.12)", // More visible hover state
          },
          divider: "rgba(255, 255, 255, 0.12)",
        }
      : {
          // Light Mode
          primary: {
            main: "#2563eb", // Modern blue
            light: "#3b82f6",
            dark: "#1d4ed8",
          },
          secondary: {
            main: "#7c3aed", // Violet
          },
          background: {
            default: "#e2e8f0", // Slate 200 - Darker than before to make paper pop
            paper: "#ffffff",
          },
          text: {
            primary: "#0f172a", // Slate 900
            secondary: "#334155", // Slate 700 - Slightly darker for readability
          },
          action: {
            selected: "rgba(37, 99, 235, 0.16)", // More visible selected state in light mode
            hover: "rgba(37, 99, 235, 0.08)", // More visible hover
          },
          divider: "rgba(0, 0, 0, 0.12)", // Stronger divider
        }),
  },
  typography: {
    fontFamily: "'Inter', 'Roboto', 'Helvetica', 'Arial', sans-serif",
    h1: { fontWeight: 700 },
    h2: { fontWeight: 700 },
    h3: { fontWeight: 600 },
    h4: { fontWeight: 600 },
    h5: { fontWeight: 600 },
    h6: { fontWeight: 600 },
    button: {
      textTransform: "none",
      fontWeight: 600,
    },
  },
  shape: {
    borderRadius: 12,
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          borderRadius: "8px",
          padding: "8px 16px",
          boxShadow: "none",
          "&:hover": {
            boxShadow:
              "0 4px 6px -1px rgba(0, 0, 0, 0.12), 0 2px 4px -1px rgba(0, 0, 0, 0.08)",
          },
        },
        contained: {
          boxShadow:
            "0 1px 3px 0 rgba(0, 0, 0, 0.1), 0 1px 2px 0 rgba(0, 0, 0, 0.06)",
        },
      },
      defaultProps: {
        disableElevation: true,
      },
    },
    MuiPaper: {
      styleOverrides: {
        root: {
          backgroundImage: "none",
        },
        rounded: {
          borderRadius: "16px",
        },
        elevation1: {
          boxShadow:
            "0 1px 3px 0 rgba(0,0,0,0.1), 0 1px 2px -1px rgba(0,0,0,0.1)",
        },
        elevation2: {
          boxShadow:
            "0 4px 6px -1px rgba(0,0,0,0.12), 0 2px 4px -2px rgba(0,0,0,0.12)",
        },
      },
    },
    MuiAppBar: {
      styleOverrides: {
        root: {
          backgroundColor: mode === "dark" ? "#1e293b" : "#ffffff",
          color: mode === "dark" ? "#f8fafc" : "#0f172a",
          boxShadow:
            mode === "dark"
              ? "0 1px 3px 0 rgba(0,0,0,0.3)"
              : "0 1px 3px 0 rgba(0,0,0,0.1), 0 1px 2px -1px rgba(0,0,0,0.1)",
          backgroundImage: "none",
        },
      },
    },
    MuiCard: {
      styleOverrides: {
        root: {
          borderRadius: "16px",
          boxShadow:
            "0 4px 6px -1px rgba(0,0,0,0.1), 0 2px 4px -2px rgba(0,0,0,0.1)",
        },
      },
    },
    MuiTextField: {
      styleOverrides: {
        root: {
          "& .MuiOutlinedInput-root": {
            borderRadius: "8px",
          },
        },
      },
    },
  },
});

export const createAppTheme = mode => createTheme(getDesignTokens(mode));
